
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[category-name]",
      function () {
        return require("private-next-pages/category/[category-name]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[category-name]"])
      });
    }
  